/* Royal Chic by Priti — Premium UX layer (sticky ATC + description accordion)
   Progressive enhancement only. No dependencies. Safe if elements absent. */
(function () {
  'use strict';
  var onReady = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ---------- 1. Mobile sticky Add-to-Cart / Buy-now bar ---------- */
  function initStickyAtc() {
    var bar = document.getElementById('RcStickyAtc');
    if (!bar) return;
    var form = document.querySelector('product-form form, form[action$="/cart/add"]');
    var mainAtc = form ? form.querySelector('[name="add"], button[type="submit"]') : null;
    var idInput = bar.querySelector('input[name="id"]');
    var atcBtn = bar.querySelector('.rc-atc');
    var buyBtn = bar.querySelector('.rc-buy');
    var priceEl = bar.querySelector('.rc-sticky__price');
    document.body.classList.add('rc-has-sticky');

    // Sync selected variant id + availability from the live product form
    function syncVariant() {
      var liveId = form ? form.querySelector('input[name="id"]') : null;
      if (liveId && idInput) idInput.value = liveId.value;
      var soldOut = mainAtc && (mainAtc.disabled || /sold|unavailable/i.test(mainAtc.textContent || ''));
      if (atcBtn) {
        atcBtn.disabled = !!soldOut;
        atcBtn.textContent = soldOut ? 'Sold out' : 'Add';
      }
      if (buyBtn) buyBtn.disabled = !!soldOut;
      // Mirror current price text if present on page
      var live = document.querySelector('.price__container .price-item--sale, .price__container .price-item--regular');
      if (live && priceEl) priceEl.childNodes[0] && (priceEl.childNodes[0].nodeValue = live.textContent.trim());
    }
    syncVariant();
    // Re-sync on variant change (Dawn dispatches on the variant radios/selects + form)
    document.addEventListener('change', function (e) {
      if (form && form.contains(e.target)) setTimeout(syncVariant, 60);
    });
    var pi = document.querySelector('variant-radios, variant-selects');
    if (pi) new MutationObserver(function(){ setTimeout(syncVariant, 60); })
      .observe(pi, { subtree: true, attributes: true, childList: true });

    // Sticky ATC submits via fetch (AJAX) and opens the cart drawer if present
    if (atcBtn) atcBtn.addEventListener('click', function () {
      if (!idInput || !idInput.value) { if (form) form.submit(); return; }
      atcBtn.textContent = 'Adding…'; atcBtn.disabled = true;
      fetch(window.routes ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      }).then(function (r) { return r.json(); }).then(function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.classList.remove('is-empty');
          // refresh drawer contents
          fetch('/?sections=cart-drawer').then(function(){ drawer.open && drawer.open(); });
          location.href = window.routes ? window.routes.cart_url : '/cart';
        } else {
          location.href = window.routes ? window.routes.cart_url : '/cart';
        }
      }).catch(function () { if (form) form.submit(); });
    });

    // Buy now → add then jump to checkout
    if (buyBtn) buyBtn.addEventListener('click', function () {
      if (!idInput || !idInput.value) return;
      buyBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      }).then(function () { location.href = '/checkout'; })
        .catch(function () { location.href = '/cart'; });
    });

    // Reveal the bar after the user scrolls past the main buy buttons
    var anchor = mainAtc || document.querySelector('.product__info-container');
    function toggle() {
      if (!anchor) { bar.classList.add('is-visible'); return; }
      var r = anchor.getBoundingClientRect();
      var past = r.bottom < 0 || r.top > window.innerHeight;
      bar.classList.toggle('is-visible', past);
    }
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);
    toggle();
  }

  /* ---------- 2. Condense long description into an accordion ---------- */
  function initDescriptionAccordion() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.closest('details')) return;
    if ((desc.textContent || '').trim().length < 160) return; // short copy: leave inline
    var details = document.createElement('details');
    details.className = 'accordion product__accordion rc-desc-accordion';
    var summary = document.createElement('summary');
    summary.innerHTML = '<div class="summary__title"><span class="accordion__title">Description</span></div>' +
      '<span class="icon-caret"><svg viewBox="0 0 10 6" class="icon icon-caret" xmlns="http://www.w3.org/2000/svg" width="10" height="6"><path d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646A.5.5 0 0 0 .646 1.354l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708Z" fill="currentColor"></path></svg></span>';
    var content = document.createElement('div');
    content.className = 'accordion__content';
    desc.parentNode.insertBefore(details, desc);
    details.appendChild(summary);
    details.appendChild(content);
    content.appendChild(desc);
  }

  onReady(function () {
    try { initStickyAtc(); } catch (e) {}
    try { initDescriptionAccordion(); } catch (e) {}
  });
})();
